import React from 'react';
import { Link } from 'react-router-dom';
import { brandLogo } from '../../config/brand';
import '../../styles/auth.css';

// Presentational page chrome shared by every Auth V2 screen (Login now,
// Register/reset later). Carries no Firebase/session logic — only layout.
// `lean` is optional: on mobile it nudges a short screen (Register's success
// step) a bit above dead-center instead of leaving equal empty space above
// and below; unused by Login, so Login's centering is unaffected.
export default function AuthShell({ children, footer, lean = false }) {
  return (
    <div className="auth-page">
      <div className="auth-backdrop" aria-hidden="true" />
      <div className={`auth-container${lean ? ' auth-container-lean' : ''}`}>
        <Link to="/" className="auth-brand">
          <img src={brandLogo} alt="" width="34" height="34" />
          <span>NSARA</span>
        </Link>
        <div className="auth-card">{children}</div>
        {footer && <div className="auth-footer">{footer}</div>}
      </div>
    </div>
  );
}
